import React from "react";
import { Logo } from "../Logo";
import { monoFont } from "./SectionHeading";

export default function Footer() {
  return (
    <footer
      className="border-t border-neutral-200 bg-[#fafafa] px-6 py-12 lg:px-10"
      style={{ fontFamily: "var(--font-geist)" }}
    >
      <div className="mx-auto flex max-w-6xl flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <div className="flex items-center gap-2">
            <Logo />
            <span className="text-[17px] font-semibold tracking-[-0.02em] text-neutral-900">
              fluvo
            </span>
          </div>
          <p className="mt-3 text-[14px] text-neutral-500">
            Automated customer engagement, powered by AI
          </p>
          <a
            href="mailto:hello@fluvo.ai"
            className="mt-1 inline-block text-[14px] text-neutral-700 underline underline-offset-4"
          >
            hello@fluvo.ai
          </a>
        </div>
        <p className="text-[12px] text-neutral-400" style={monoFont}>
          © {new Date().getFullYear()} Fluvo. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
